// extracted by mini-css-extract-plugin
export default {"content":"Settings_content__KjIjB","hidden":"Settings_hidden__Tkh1X","links":"Settings_links__Vdzuq"};